module.exports = __webpack_public_path__ + "static/img/a.1e2ea70f.svg";